import { useState } from 'react';
import { useWatch } from 'react-hook-form';
import { AudienceCriteria } from '../../../AudienceForm/sections/AudienceCriteria.tsx';
import type { AudienceForm } from '../../../AudienceForm/types.ts';
import { filterNonEmptyGroups } from '../../../AudienceForm/utils/filterNonEmptyGroups.ts';
import { AudienceFormProvider } from '../../components/AudienceFormProvider/AudienceFormProvider.tsx';

function AudienceCriteriaTabContent() {
  const observableExcludesGroups = useWatch<AudienceForm, 'normalized_definition.excludes.groups'>({
    name: 'normalized_definition.excludes.groups',
  });

  const [showExcludeSection, setShowExcludeSection] = useState<boolean>(
    filterNonEmptyGroups(observableExcludesGroups ?? []).length > 0
  );

  return (
    <AudienceCriteria
      isEdit={false}
      hideCriteria={false}
      showDivider={false}
      showExcludeSection={showExcludeSection}
      setShowExcludeSection={setShowExcludeSection}
    />
  );
}

export function AudienceCriteriaTab() {
  return (
    <AudienceFormProvider>
      <AudienceCriteriaTabContent />
    </AudienceFormProvider>
  );
}
